import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../store/app.reducer";
import { map } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { NotificationService } from "../services/notification.service";
import { AppModeService } from "../garbage/app-mode.service";

@Component({
  selector: "app-bottom-nav",
  imports: [RouterLink, RouterLinkActive, AsyncPipe],
  templateUrl: "./bottom-nav.component.html",
  styleUrl: "./bottom-nav.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomNavComponent {
  private readonly store = inject(Store<AppState>);
  protected readonly notificationService = inject(NotificationService);
  protected readonly appMode = inject(AppModeService);
  protected readonly user$ = this.store.select("auth").pipe(map((authState) => authState.user));
  protected readonly isAuthenticated$ = this.user$.pipe(map((user) => !!user));
  protected readonly isAdmin$ = this.user$.pipe(
    map(
      (user) =>
        !!user &&
        (user.isStaff || user.isSuperuser || user.groups.includes("Admin") || user.groups.includes("admin"))
    )
  );
}
